import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserFitFiveGame from 'src/games/FitFiveGame/Main';

interface FitFiveGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class FitFiveGame extends React.Component<FitFiveGameProps> {
    constructor(props: FitFiveGameProps) {
        super(props);
        bindAllOfThis(this, FitFiveGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserFitFiveGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default FitFiveGame;



// WEBPACK FOOTER //
// ./src/pages/game/FitFiveGame.tsx